import { useLayoutEffect, useRef, useState } from 'react';
import { computeImageOnlyFitSquare } from './slideLayout.ts';

export function useStageImageOnlyFitSquare(enabled: boolean) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [fitSide, setFitSide] = useState<number | null>(null);

  useLayoutEffect(() => {
    if (!enabled) {
      return;
    }
    const el = containerRef.current;
    if (!el) {
      return;
    }

    const update = () => {
      const rect = el.getBoundingClientRect();
      setFitSide(
        computeImageOnlyFitSquare({
          width: rect.width,
          height: rect.height,
        }),
      );
    };

    update();
    const observer = new ResizeObserver(update);
    observer.observe(el);
    return () => observer.disconnect();
  }, [enabled]);

  return { containerRef, fitSide };
}
